module.exports = __webpack_public_path__ + "img/5_Middle Ascending Colon(and Ascending colon).9b338678.png";